<script setup lang="ts">
    import type { DropdownMenuRadioItemEmits, DropdownMenuRadioItemProps } from 'reka-ui';
    import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';

    import { CheckIcon } from '@heroicons/vue/24/outline';
    import { DropdownMenuItemIndicator, DropdownMenuRadioItem, useForwardPropsEmits } from 'reka-ui';
    import { cn } from '../utils';

    const props = defineProps<DropdownMenuRadioItemProps & { class?: HTMLAttributes['class'] }>();

    const emits = defineEmits<DropdownMenuRadioItemEmits>();

    const delegatedProps = reactiveOmit(props, 'class');

    const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
    <DropdownMenuRadioItem
        data-slot="dropdown-menu-radio-item"
        v-bind="forwarded"
        :class="
            cn(
                'focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*=\'size-\'])]:size-4',
                props.class,
            )
        "
    >
        <span class="pointer-events-none absolute left-2 flex size-3.5 items-center justify-center">
            <DropdownMenuItemIndicator>
                <slot name="indicator-icon">
                    <CheckIcon class="size-4" />
                </slot>
            </DropdownMenuItemIndicator>
        </span>
        <slot />
    </DropdownMenuRadioItem>
</template>
